import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index'
import '@/components/newComponents/registerGlobComp'
import echarts from 'echarts'
import elementui, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/global.scss'
import Moment from "moment"
import Vuex from "vuex"
import './resgisterServiceWorker'
import VeLine from 'v-charts/lib/line.common'
import VeHistogram from 'v-charts/lib/histogram.common'
import VeRing from 'v-charts/lib/ring.common'
import Vue2OrgTree from 'vue2-org-tree'
import './assets/font/font.css' // 引入字体PingFang
import './assets/iconfont/iconfont.css' // 引入图标
import gojs from 'gojs'
import '@/assets/all_iconfont/iconfont.css';
import '@/assets/iconfont_v1/iconfont.css';
import '@/assets/iconfront-jd/iconfont.css';
import axios from 'axios'
import utils from './utils/util.js'
import constant from './utils/constant.js'
import clipboard from "clipboard";
import * as fillters from './utils/fillter';
import './assets/iconfont/iconfont.css';
//el-input挂载
import onlyNumber from '@/directive/el-input'; //添加此行=>自定义全局指令

import JSEncrypt from 'jsencrypt'
import { uploadPointData } from "@/api/burialPoint/index.js"

Vue.prototype.clipboard = clipboard;
import VueClipboard from 'vue-clipboard2'

// 全局组件
import newButton from "@/components/new-button/index.vue"
Vue.component("newButton", newButton);


Vue.use(VueClipboard);
Vue.use(onlyNumber);

Vue.use(Vuex);
// Vue.use(animate);
Object.keys(fillters).forEach(key => {
  Vue.filter(key, fillters[key])
});

Vue.use(utils);
Vue.use(constant);
Vue.use(Vue2OrgTree);
Vue.prototype.$http = axios;
Vue.use(elementui, { size: 'small', zIndex: 3000 });
Vue.use(echarts);
Vue.prototype.$go = gojs
Vue.prototype.$make = gojs.GraphObject.make
Vue.component(VeLine.name, VeLine)
Vue.component(VeHistogram.name, VeHistogram)
Vue.component(VeRing.name, VeRing)
Vue.prototype.$newIds = ["2", "13", "14", "15", "16", "17", "18", "26", "27", "28", "29", "30", "35", "36", "43", "44", "45",
  "46", "50", "51", "68", "69", "76", "77", "78", "79", "81", "83", "85", "87", "88", "89", "90", "91", "92", "93", "94", "95", "96", "97", "98"];
Vue.prototype.moment = Moment;

Vue.prototype.$myVue = Vue;

Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false;

Vue.prototype.$BaseUrl = 'http://cdp.yucrm.cn/api'; //导出地址前缀
Vue.prototype.$imgUrl = 'http://qqdadmin.tj9.co/api/'; //图片地址前缀
Vue.prototype.$BaseUrl3 = 'http://39.103.132.51:10060/'; // 积分导出
Vue.prototype.$tbLink = 'https://m.duanqu.com?_ariver_appid=3000000025684595&nbsv=0.0.25&nbsource=debug&nbsn=TRIAL&_mp_code=tb'


Array.prototype.max = function () {
  return Math.max.apply({}, this);
}
Vue.prototype.$message = function (msg) {
  return Message({
    message: msg,
    duration: 1000
  })
}
Vue.prototype.$message.warning = function (msg) {
  return Message({
    message: msg,
    type: "warning",
    duration: 1000
  })
}
Vue.prototype.$message.success = function (msg) {
  return Message({
    message: msg,
    duration: 1000,
    type: "success"
  })
}
Vue.prototype.$message.error = function (msg) {
  return Message({
    message: msg,
    duration: 1000,
    type: "error"
  })
}
Vue.prototype.bus = new Vue()
//按钮防止重复点击方法，直接在el-button上加上v-preventReClick指令就可以了
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
})

// 输入框只能输入数字
Vue.directive('numeric-only', {
  bind(el) {
    el.addEventListener('input', (event) => {
      const inputValue = event.target.value;
      const filteredValue = inputValue.replace(/[^\d.]/g, '');
      event.target.value = filteredValue;
    });
  },
});

// 输入框只能输入整数
Vue.directive('numOnly', {
  bind(el) {
    el.addEventListener('input', (event) => {
      const inputValue = event.target.value;
      event.target.value = inputValue.replace(/[^\d]/g, "");
    });
  },
});

// 输入框只能输入整数 - 小于99999
Vue.directive('numOnly9', {
  bind(el) {
    el.addEventListener('input', (event) => {
      const inputValue = event.target.value;
      event.target.value = inputValue.replace(/[^\d]/g, "");
      if (Number(event.target.value) > Number(99999)) {
        event.target.value = 99999;
      }
    });
  },
});

// 输入框只能输入正整数
Vue.directive('numZOnly', {
  bind(el) {
    el.addEventListener('input', (event) => {
      const inputValue = event.target.value;
      event.target.value = inputValue.replace(/^(0+)|[^\d]+/g, "");
    });
  },
});

// 输入框限制大于等于0正数，带两个小数
Vue.directive('numHave2Decimal', {
  bind(el) {
    el.addEventListener('input', (event) => {
      let inputValue = event.target.value;
      inputValue = inputValue.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')
      let value = isNaN(inputValue) ? "" : inputValue.toString();
      event.target.value = value;
    });
  }
});

// 输入框限制大于等于0正数，带1个小数
Vue.directive('numHave1Decimal', {
  bind(el) {
    el.addEventListener('input', (event) => {
      let inputValue = event.target.value;
      inputValue = inputValue.replace(/^\D*([0-9]\d*\.?\d{0,1})?.*$/, '$1')
      let value = isNaN(inputValue) ? "" : inputValue.toString();
      event.target.value = value;
    });
  }
});

Vue.directive('numNoZero', {
  bind(el) {
    el.addEventListener('input', (event) => {
      const inputValue = event.target.value + "";
      if (inputValue.length == 1) {
        event.target.value = inputValue.replace(/0/g, "");
      }
      if (inputValue.includes('.') && inputValue.split('.')[1].length >= 2) {
        event.target.value = inputValue.split('.')[0] + "." + inputValue.split('.')[1].split("")[0] + inputValue.split('.')[1].split("")[1]
      }
    });
  },
});

// 权限位
Vue.directive('permission', {
  bind(el, binding) {
    let permission = []
    let permissionsInterval = setInterval(() => {
      if (store.getters.sellerData && store.getters.sellerData.permissions) {
        permission = store.getters.sellerData.permissions;
        console.log("permission", permission)
        if (permission.length) {
          if (permission.includes("*:*:*")) {
            // 有全部权限
            el.style.display = 'inline-block'
          } else {
            if (permission.includes(binding.value)) {
              el.style.display = 'inline-block'
            } else {
              el.style.display = 'none'
            }
          }
        } else {
          el.style.display = 'none'
        }
        clearInterval(permissionsInterval);
      }
    }, 150);
  }
})

// 埋点
// 定时器标识
let timer = null
let timeEnter = null
let times = 0

// 埋点计时器
Vue.prototype.setIntervalFun = async function (name, firstClassify, secondClassify, id) {
  if (!id) return
  timer = setTimeout(() => {
    times = times + 1
    // 页面停留超过1小时，停止埋点
    if (times >= 3600) {
      // console.log(times);
      this.clearBuriedPoint()
      // console.log('停止埋点');
      return
    }
    this.buriedPointTimes(firstClassify, secondClassify, name, id)
    // console.log('埋点成功', name, firstClassify, secondClassify);
  }, 2000)
}
// 清除埋点
Vue.prototype.clearBuriedPoint = function () {
  clearTimeout(timer)
}
// 页面埋点
Vue.prototype.buriedPoint = async function (action, firstClassify, secondClassify, name, type) {
  let flage = false
  if (!flage) {
    this.clearBuriedPoint()
    clearTimeout(timeEnter)
    flage = true
  }
  if (flage) {
    setTimeout(async () => {
      times = 0;
      var route = this.$route.path;
      let params = {
        platform: 'hyt',
        venderId: '',
        shopTitle: '',
        source: 0,//来源 0:pc端 1:移动端
        action: action,//类型 1进入页面 2点击按钮 3授权进入 4操作
        url: route,// 路径
        name: name,//"页面/按钮名称（1、2类型时要有）",
        sign: encryptMI(),//JSE加密
        firstClassify: firstClassify, // 一级分类
        secondClassify: secondClassify, // 二级分类
        type: type
      }
      // 当前店铺信息
      params.venderId = store.state.sellerData.platformAccountInfo.platformCompanyUserId;
      params.shopTitle = store.state.sellerData.platformAccountInfo.companyName;
      let res = await uploadPointData(params)
      if (res.code) {
        this.buriedPointTimes(firstClassify, secondClassify, name, res.data)
      }
    }, 500)
  }
}

// 轮询埋点
Vue.prototype.buriedPointTimes = async function (firstClassify, secondClassify, name, id) {
  var route = this.$route.path;
  let params = {
    platform: 'hyt',
    venderId: '',
    shopTitle: '',
    source: 0,//来源 0:pc端 1:移动端
    action: 5,//类型 1进入页面 2点击按钮 3授权进入 4操作
    url: route,// 路径
    name: name,//"页面/按钮名称（1、2类型时要有）",
    sign: encryptMI(),//JSE加密
    firstClassify: firstClassify, // 一级分类
    secondClassify: secondClassify, // 二级分类
    requestId: id // 请求id
  };
  params.shopTitle = store.state.sellerData.platformAccountInfo.companyName;
  params.venderId = store.state.sellerData.platformAccountInfo.platformCompanyUserId;
  // 调用埋点
  await uploadPointData(params);
  // 轮询-埋点
  this.clearBuriedPoint()
  this.setIntervalFun(name, firstClassify, secondClassify, id)
}

// JSEncrypt加密
const encryptMI = function (origin = Date.now()) {
  // 公钥
  const key = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDa+vHCmfKZxVdMBbp69Stu4u11BlOqfEDXK8HqZJ8dKHArYd+78wMzvpQZcWFtdix8MYaTLQERIaxjRoLrGYvYiONi+dKaZ/SSAI8boATYb1Wimz/ocUIGGj2SSZwQ6l5xzOu7orKVdrzUMpqETbuxRwAeMe1ZP/YQ20aXmmGBgwIDAQAB'
  let encrypt = new JSEncrypt()
  encrypt.setPublicKey(key)
  return encrypt.encrypt(origin + '')
}

// 正式环境不打印
if (
  window.location.href.indexOf("test") > -1 || window.location.href.indexOf("local") > -1
) {
  console.log("可以打印")
} else {
  console.log = function () { };
}


router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
})
router.beforeEach((to, from, next) => {
  next();
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
